// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sHptw5JwH8AVRxZ76_fI {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 1rem;
  font-size: 0.75rem;
  line-height: 0.875rem;
  font-weight: 600;
  color: var(--white);
  background-color: var(--header-basket-badge-color);
  padding: 0.0625rem;
  border-radius: 0.5rem;
  position: absolute;
  top: 0.75rem;
  left: 50%;
}

.uuaBmeZgVUZd0oqzD_zJ {
  color: var(--header-basket-badge-color);
  background-color: var(--white);
  top: 30%;
  left: 45%;
}

@media only screen and
  (max-width: 639px) {
  .uuaBmeZgVUZd0oqzD_zJ {
    top: 0.75rem;
    left: 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BasketQuantity/BasketQuantity.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAe;EACf,qBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;EAClD,kBAAY;EACZ,qBAAkB;EAClB,kBAAkB;EAClB,YAAS;EACT,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,QAAQ;EACR,SAAS;AACX;;AAEA;;EACE;IACE,YAAS;IACT,SAAS;EACX;AACF","sourcesContent":[".basketQuantity {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 16px;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: 600;\n  color: var(--white);\n  background-color: var(--header-basket-badge-color);\n  padding: 1px;\n  border-radius: 8px;\n  position: absolute;\n  top: 12px;\n  left: 50%;\n}\n\n.basketQuantityV2 {\n  color: var(--header-basket-badge-color);\n  background-color: var(--white);\n  top: 30%;\n  left: 45%;\n}\n\n@media (--mobile) {\n  .basketQuantityV2 {\n    top: 12px;\n    left: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"basketQuantity": `sHptw5JwH8AVRxZ76_fI`,
	"basketQuantityV2": `uuaBmeZgVUZd0oqzD_zJ`
};
export default ___CSS_LOADER_EXPORT___;
